import BackgroundImg2 from "../components/BackgroundImg2/BackgroundImg2"
import ContactForm from "../components/ContactForm/ContactForm"
import Footer from "../components/Footer/Footer"

const Contact = () => {
  return (
    <div>
      <BackgroundImg2 heading='CONTACT' text='Get in touch' />
      <ContactForm />
      <Footer />
    </div>
  )
}

export default Contact